import type { NodeId } from '@ipfabric/utils';
import type {
  PacketDetail,
  PathLookupPathInspectorSelectedPacketSource,
} from 'components/DeviceView/deviceViewTypes';
import { isPathLookupNodeData } from 'components/Graph/helpers/isPathLookupNodeData';
import type { GraphData } from 'components/Graph/model/GraphData';

export const getAutoselectedPacketSource = (
  graphData: GraphData,
  nodeId: NodeId,
  packetDetail: PacketDetail,
): PathLookupPathInspectorSelectedPacketSource => {
  const nodeData = graphData.nodes[nodeId];
  if (nodeData !== undefined && isPathLookupNodeData(nodeData)) {
    if (nodeData.acceptedPackets?.[packetDetail.id]) {
      return 'acceptedPackets';
    }
    if (nodeData.droppedPackets?.[packetDetail.id]) {
      return 'droppedPackets';
    }
    if (nodeData.generatedPackets?.[packetDetail.id]) {
      return 'generatedPackets';
    }
  }
  return 'edge';
};
